module.exports = __webpack_public_path__ + "media/images/global/header-logo-8021a622d7b04dfaeb3df1f3cc405026.png";